import PopupResultFormComponent from '../../form/js/popup-result-form.component';

//just extend PopupResultFormComponent behavior but use existing class name and id
export default class ForgotPasswordFormComponent extends PopupResultFormComponent {
}



// WEBPACK FOOTER //
// ./app/components/auth-forms/js/forgot-password-form.component.js